import React, { useEffect, useState } from 'react';
import { ValidationReport } from './types/validation';
import { SummaryCard } from './components/SummaryCard';
import { StatuteSection } from './components/StatuteSection';
import validationData from './data/validation-results.json';
import './App.css';

const App: React.FC = () => {
  const [report, setReport] = useState<ValidationReport | null>(null);
  const [isEmbed, setIsEmbed] = useState(false);

  useEffect(() => {
    // Check if we're in embed mode
    const params = new URLSearchParams(window.location.search);
    setIsEmbed(params.get('embed') === 'true');

    // Load validation data
    setReport(validationData as ValidationReport);
  }, []);

  if (!report) {
    return <div className="loading">Loading validation results...</div>;
  }

  return (
    <div className={`app ${isEmbed ? 'embed-mode' : ''}`}>
      {!isEmbed && (
        <header className="header">
          <h1>Cosilico Validation Dashboard</h1>
          <p className="subtitle">
            Comparing encoded tax/benefit rules against external validators
          </p>
        </header>
      )}

      {report.isSampleData && (
        <div className="sample-banner">
          <span className="sample-icon">⚠️</span>
          <span>SAMPLE DATA — Illustrative only. Real validation pipeline in development.</span>
        </div>
      )}

      <main className="main">
        <SummaryCard report={report} />

        <div className="sections">
          <h2>By Statute Section</h2>
          {report.sections.map((section) => (
            <StatuteSection key={section.section} section={section} />
          ))}
        </div>
      </main>

      {!isEmbed && (
        <footer className="footer">
          <p>
            <a
              href="https://github.com/CosilicoAI/cosilico-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              cosilico-us
            </a>
            {' · '}
            <a
              href="https://github.com/CosilicoAI/cosilico-validators"
              target="_blank"
              rel="noopener noreferrer"
            >
              cosilico-validators
            </a>
            {' · '}
            <a href="https://cosilico.ai" target="_blank" rel="noopener noreferrer">
              cosilico.ai
            </a>
          </p>
        </footer>
      )}
    </div>
  );
};

export default App;
